import { getPaginationMessages } from "../axios/chat";
import { Message } from "../types";
import useAppStore from "../stores/appStore";
import { getUserIdFromToken } from "./authToken";

export type PaginationParams = {
  message_id?: string;
  direction?: "middle" | "up" | "down";
  number?: number;
};

const inFlightRequests = new Map<string, Promise<Message[]>>();

export function buildPaginationKey(params: PaginationParams): string {
  const { focus, domain } = useAppStore.getState();
  return JSON.stringify({
    user_id: getUserIdFromToken() ?? "",
    focus: focus ?? "",
    domain: domain ?? "",
    message_id: params.message_id ?? "",
    direction: params.direction ?? "",
    number: params.number ?? 0,
  });
}

export function clearInFlightPagination(): void {
  inFlightRequests.clear();
}

export async function paginateMessages(
  params: PaginationParams,
): Promise<Message[]> {
  const key = buildPaginationKey(params);
  const existing = inFlightRequests.get(key);
  if (existing) {
    return existing;
  }

  const request = getPaginationMessages(params).finally(() => {
    if (inFlightRequests.get(key) === request) {
      inFlightRequests.delete(key);
    }
  });

  inFlightRequests.set(key, request);
  return request;
}
